import { STORAGE_KEYS } from "./constants";

export type AIProvider = "openai" | "anthropic" | "google";

export interface ModelConfig {
  id: string;
  name: string;
  provider: AIProvider;
  model: string;
  description: string;
}

export const AVAILABLE_MODELS: ModelConfig[] = [
  {
    id: "gpt-5.5",
    name: "GPT-5.5",
    provider: "openai",
    model: "gpt-5.5-2026-04-23",
    description: "Latest OpenAI model with vision",
  },
  {
    id: "gpt-4o",
    name: "GPT-4o",
    provider: "openai",
    model: "gpt-4o",
    description: "Fast multimodal model",
  },
  {
    id: "gemini-2.5-pro",
    name: "Gemini 2.5 Pro",
    provider: "google",
    model: "gemini-2.5-pro-preview-06-05",
    description: "Google's latest model",
  },
  {
    id: "gemini-2.5-flash",
    name: "Gemini 2.5 Flash",
    provider: "google",
    model: "gemini-2.5-flash-preview-05-20",
    description: "Fast & efficient",
  },
];

export const DEFAULT_MODEL_ID = "gpt-5.5";

export function getSelectedModelId(): string {
  try {
    return localStorage.getItem(STORAGE_KEYS.SELECTED_MODEL) || DEFAULT_MODEL_ID;
  } catch {
    return DEFAULT_MODEL_ID;
  }
}

export function setSelectedModelId(modelId: string): void {
  try {
    localStorage.setItem(STORAGE_KEYS.SELECTED_MODEL, modelId);
  } catch (e) {
    console.error("Failed to save model selection:", e);
  }
}

export function getModelConfig(modelId: string): ModelConfig | undefined {
  return AVAILABLE_MODELS.find((m) => m.id === modelId);
}
